import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
//authConfig
import { loginRequest } from "../config/authConfig";
//context
import { AppTokenProvider } from '../contexts/AppTokenContext';
import { UserProvider } from "../contexts/UserContext";
//components
import { MainContainer } from "../components/MainContainer";

export function UseAccessToken() {
    const { instance, accounts } = useMsal();
    const [accessTokenSsoObj, setAccessTokenSsoObj] = useState({});
    const [userDetails, setUserDetails] = useState("");
    const [userSsoId, setUserSsoId] = useState("");

    const getUserAccessToken = () => {
        if (accounts.length > 0) {
            setUserDetails(accounts[0]);
            let ssoId = accounts[0].username.split("@")[0];
            setUserSsoId(ssoId);
            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                console.log("response", response)
                setAccessTokenSsoObj({
                    ssoId: ssoId,
                    accessToken: response.accessToken
                });
            }).catch(error => {
                // acquireTokenSilent can fail for a number of reasons, fallback to interaction
                console.log(error);
            });
        }
    }

    useEffect(() => {
        getUserAccessToken();
    }, []);

    return (
        <AppTokenProvider value={accessTokenSsoObj.accessToken}>
            <UserProvider value={{ loggedInUserData: userDetails, userSsoId: userSsoId }}>
                <MainContainer />
            </UserProvider>
        </AppTokenProvider>
    )
}
